'use client'

import { AiOutlineArrowUp } from 'react-icons/ai'

import { Button } from '../../../_components/ui/button'

const FooterGoToTop = () => {
  const goToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
  return (
    <Button
      className="flex gap-1 text-base font-bold text-brand-grayscale-8 sm:text-xs"
      variant="link"
      onClick={goToTop}
    >
      Voltar ao topo
      <AiOutlineArrowUp />
    </Button>
  )
}

export default FooterGoToTop
